import { render } from "./WonderKitDisplay.vue?vue&type=template&id=0bdbdf28&scoped=true"
import script from "./WonderKitDisplay.vue?vue&type=script&lang=js"
export * from "./WonderKitDisplay.vue?vue&type=script&lang=js"

import "./WonderKitDisplay.vue?vue&type=style&index=0&id=0bdbdf28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdbdf28"]])

export default __exports__